export var ManageUsersTab;
(function (ManageUsersTab) {
    ManageUsersTab[ManageUsersTab["Users"] = 0] = "Users";
    ManageUsersTab[ManageUsersTab["Groups"] = 1] = "Groups";
})(ManageUsersTab || (ManageUsersTab = {}));
export var ManageUsersSubjects;
(function (ManageUsersSubjects) {
    ManageUsersSubjects["UserRoleSelect"] = "select-role";
    ManageUsersSubjects["CreateUser"] = "create-user";
    ManageUsersSubjects["FullNameInput"] = "full-name-input";
    ManageUsersSubjects["UsernameInput"] = "username-input";
})(ManageUsersSubjects || (ManageUsersSubjects = {}));
export var ManageAuthGroupsSubjects;
(function (ManageAuthGroupsSubjects) {
    ManageAuthGroupsSubjects["GroupNameInput"] = "group-name-input";
})(ManageAuthGroupsSubjects || (ManageAuthGroupsSubjects = {}));
//# sourceMappingURL=manage-users.enum.js.map